<template>
  <div>
    <nav class="header uk-navbar uk-navbar-container uk-margin">
      <div class="contntainer">
        <!--<b-button class="navigation-button h1 mb-2" v-b-toggle.sidebar-no-header
          ><i class="bi bi-list"></i
        ></b-button>-->
        <div class="logo">
          <router-link :to="{ name: 'home' }" class="uk-navbar-item uk-logo">
            <TenantLogo id="main-logo" logo-class="" />
            <p>{{ $store.getters.clubNameShort }}</p>
          </router-link>
        </div>
        <div class="header-buttons" v-if="$route.name !== 'invitationSignUp'">
          <!-- Season Phase Badge -->
          <SeasonPhaseBadge />

          <!-- Global Season Selector (admins/coaches) -->
          <SeasonSelector />

          <!-- Version Display - Show in all environments for testing -->
          <div class="version-info" v-if="versionInfo.version">
            <span class="version-badge">v{{ versionInfo.version }}</span>
            <span class="build-date" v-if="showDetailedVersion">
              {{ formatBuildDate(versionInfo.buildDate) }}
            </span>
          </div>

          <router-link :to="{ name: 'Settings' }">
            <div class="user-photo-info">
              <img v-if="userData.userImage !== '' && userData.userImage !== null" :src="getImgUrl(userData.userImage)"
                alt="" />
              <TenantLogo v-else logo-class="login-logo" />
            </div>
          </router-link>
          <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <i class="bi bi-gear-fill" aria-hidden="true"></i><span class="sr-only">Settings</span>
            </template>
            <router-link :to="{ name: 'Settings' }">settings</router-link>
            <router-link :to="{ name: 'help' }">Help & support</router-link>
            <a href="/training-course.html" target="_blank" rel="noopener noreferrer">Help / Training</a>

            <!-- Show version info in dropdown for all environments -->
            <!--<template v-if="versionInfo.version">
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="toggleVersionDetails">
                {{ showDetailedVersion ? 'Hide' : 'Show' }} Build Info
              </b-dropdown-item>
              <b-dropdown-item disabled>
                Version: {{ versionInfo.version }}
              </b-dropdown-item>
              <b-dropdown-item v-if="versionInfo.buildDate" disabled>
                Built: {{ formatBuildDate(versionInfo.buildDate) }}
              </b-dropdown-item>
              <b-dropdown-item disabled>
                Environment: {{ versionInfo.environment || 'development' }}
              </b-dropdown-item>
              <b-dropdown-item v-if="versionInfo.gitCommit && versionInfo.gitCommit !== 'unknown'" disabled>
                Commit: {{ versionInfo.gitCommit }}
              </b-dropdown-item>
            </template>-->

            <a href="javascript:;" @click="logout()">Logout</a>
          </b-dropdown>
        </div>
      </div>
    </nav>

    <!-- Read-only banner shown while browsing a past season -->
    <div
      v-if="isViewingPastSeason && $route.name !== 'invitationSignUp'"
      class="past-season-banner"
    >
      <i class="bi bi-clock-history" aria-hidden="true"></i>
      Viewing <strong>{{ pastSeasonLabel }}</strong> season — read-only.
      <button class="past-season-banner__exit" @click="exitPastSeason">
        Back to current season
      </button>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { getAuth, signOut } from "firebase/auth";
import { CHECK_PROFILE_HAS_DATA, USER_POPULATE } from "@/store/actions/user.js";
import { Users } from "@/services/user-service.js";
import TenantLogo from "@/components/TenantLogo/index.vue";
import SeasonPhaseBadge from "@/components/SeasonPhaseBadge/index.vue";
import SeasonSelector from "@/components/SeasonSelector/index.vue";
import { getDefaultLogoUrl, getTenantImageUrl } from "@/utils/tenantLogo.js";
import { avatarUrl } from "@/utils/avatar";
import { AppActivity } from "@/services/app-activity-service.js";

export default {
  name: "App",
  components: {
    TenantLogo,
    SeasonPhaseBadge,
    SeasonSelector,
  },
  data() {
    return {
      userData: {
        name: "",
        userType: "",
      },
      versionInfo: {
        version: null,
        buildDate: null,
        environment: null,
        gitCommit: null,
        gitBranch: null,
      },
      showDetailedVersion: false,
    };
  },
  async created() {
    // Load version info
    await this.loadVersionInfo();

    this.$store.dispatch(CHECK_PROFILE_HAS_DATA).then((response) => {
      if (response === true) {
        this.setUser();
      } else {
        const clientId = JSON.parse(
          localStorage.getItem("the_w_selectedClientId"),
        );
        this.getUserById(clientId).then((response) => {
          if (response === true) {
            this.selectedUserValue = clientId;
          }
        });
      }
    });
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(["getProfile", "isViewingPastSeason", "selectedSeason"]),

    pastSeasonLabel() {
      return this.selectedSeason ? this.selectedSeason.label : "";
    },

    isProduction() {
      return (
        process.env.NODE_ENV === "production" ||
        this.versionInfo.environment === "production"
      );
    },
  },
  watch: {
    // Record an app-open once the signed-in profile is available. Throttled to
    // one event per user per day inside the service, so navigating between
    // pages (which re-mounts this layout) won't spam the events table.
    getProfile: {
      immediate: true,
      handler(profile) {
        if (profile && profile.id) {
          AppActivity.logAppOpen(profile);
        }
      },
    },
  },
  methods: {
    async loadVersionInfo() {
      try {
        const response = await fetch("/version.json");
        if (response.ok) {
          this.versionInfo = await response.json();
        } else {
          console.warn("Could not load version information");
        }
      } catch (error) {
        console.warn("Error loading version info:", error);
        // Fallback removed: package.json cannot be loaded in browser
      }
    },

    formatBuildDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return (
        date.toLocaleDateString() +
        " " +
        date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })
      );
    },

    toggleVersionDetails() {
      this.showDetailedVersion = !this.showDetailedVersion;
    },

    exitPastSeason() {
      // Passing null restores the live current-season window and reloads.
      this.$store.dispatch("selectSeason", null);
    },

    getImgUrl(pic) {
      if (pic === undefined || pic === "") {
        return "";
      }

      // The old default resolved to the club logo; a person's avatar now
      // falls back to the neutral placeholder instead (see utils/avatar.js).
      return avatarUrl(pic);
    },

    getDefaultLogoUrl() {
      return getDefaultLogoUrl();
    },

    getTenantImageUrl(imageName) {
      return getTenantImageUrl(imageName);
    },

    async getUserById(clientId) {
      const userData = {
        clientId: clientId,
        action: "getUserByID",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce.data.length > 0) {
        this.userData = responce.data[0];
        const userData = responce.data[0];
        this.$store.dispatch(USER_POPULATE, { userData });
        return true;
      }
    },

    setUser() {
      if (this.getProfile !== null) {
        this.userData = this.getProfile;
      }
    },

    async logout() {
      const auth = getAuth();
      try {
        await signOut(auth);
      } catch (error) {
        console.error("Logout error:", error);
      }
      this.$store.dispatch(AUTH_LOGOUT);
    },
  },
};
</script>
<style scoped lang="scss">
.past-season-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #fff4e8;
  color: #b35400;
  border-bottom: 1px solid #fd7e14;
  font-size: 0.9rem;
  text-align: center;

  .past-season-banner__exit {
    margin-left: 0.75rem;
    border: 1px solid #fd7e14;
    background: #fff;
    color: #b35400;
    border-radius: 4px;
    padding: 2px 10px;
    font-size: 0.8rem;
    cursor: pointer;

    &:hover {
      background: #fd7e14;
      color: #fff;
    }
  }
}

.header-buttons {
  padding-top: 0 !important;
  display: flex !important;
  align-items: center;
  gap: 1rem;

  .version-info {
    display: flex;
    flex-direction: column;
    align-items: center;

    .version-badge {
      background: #28a745;
      color: white;
      padding: 0.25rem 0.5rem;
      border-radius: 12px;
      font-size: 0.75rem;
      font-weight: 600;
      line-height: 1;
      cursor: default;
    }

    .build-date {
      font-size: 0.6rem;
      color: #6c757d;
      margin-top: 0.125rem;
      text-align: center;
    }
  }

  .user-photo-info {
    display: none;
    width: 4rem;

    img {
      width: 100%;
      height: 100%;
      border-radius: 100px;
      border: 1px solid #f4eead;
    }
  }
}

@media screen and (max-width: 768px) {
  .header-buttons {
    .version-info {
      .version-badge {
        font-size: 0.65rem;
        padding: 0.2rem 0.4rem;
      }

      .build-date {
        display: none; // Hide build date on mobile
      }
    }
  }
}

@media screen and (min-width: 1024px) {
  .header-buttons {
    .user-photo-info {
      display: block;
    }
  }
}
</style>
